module.exports = __webpack_public_path__ + "img/select-tick-red.a41ea33d.svg";